import {
    getLegacyStatsigClient,
    getStatsigClient
} from '~/common/Statsig/statsigClient';
import { isNewStatsigSDK } from '~/common/Statsig/hybridStatsig';

export const getStatsigStableID = () => {
    if (isNewStatsigSDK()) {
        const statsigClient = getStatsigClient();
        return statsigClient.getContext().stableID;
    } else {
        const Statsig = getLegacyStatsigClient();
        return Statsig.getStableID();
    }
};
